import fetch from '@adc/fetch'
import configment from '@adc/configment'
import { camelCase, omit } from 'lodash'

// import from core ?
const embeddableOperation = name =>
  [camelCase(configment.get('APP_NAME', '')), name].filter(Boolean).join('_')

const formatFormdata = formData => {
  // is_refund_address_same_as_deed_mailing_address is a temp field.
  // That's why it's stored  on the __computed__ .
  // is_refund_address_different field in the payload for
  // the mutation should be opposite of is_refund_address_same_as_deed_mailing_address in  __computed__.
  const isRefundAddressSameAsDeedMailingAddress =
    formData.trusteePurchaseProfileInput.__computed__
      .is_refund_address_same_as_deed_mailing_address

  formData.trusteePurchaseProfileInput.is_refund_address_different =
    !isRefundAddressSameAsDeedMailingAddress

  if (isRefundAddressSameAsDeedMailingAddress) {
    // wipe any previosly entered data there in case users unchecked the checkbox
    // filled some fields out and then changed their mind and checked the checkbox again
    formData.trusteePurchaseProfileInput.refund_payable_to_address = null
  }
  return omit(formData, 'trusteePurchaseProfileInput.__computed__')
}

export const TRUSTEE_PURCHASE_PROFILE_FORM_FRAGMENT = `
  fragment TrusteePurchaseProfileFormFragment on TrusteePurchaseProfile {
    purchase_profile_id
    profile_name
    customer_type
    is_default
    is_max_bid_submit
    contact_info {
      company_name
      first_name
      last_name
      email
      phone
      contact_address {
        street_address
        municipality
        country_primary_subdivision
        postal_code
      }
    }
    deed_mailing_address {
      company_name
      first_name
      last_name
      phone
      street_address
      municipality
      country_primary_subdivision
      postal_code
    }
    refund_payable_to_address {
      company_name
      first_name
      last_name
      phone
      street_address
      municipality
      country_primary_subdivision
      postal_code
    }
    is_refund_address_different
    vesting_instructions
  }
`

export const createTrusteePurchaseProfile = formData => {
  const { trusteePurchaseProfileInput } = formatFormdata(formData)

  return fetch
    .forAuctionGraph({
      query: `
       mutation ${embeddableOperation(
         'toolkitAdc_createTrusteePurchaseProfile'
       )}($input: TrusteePurchaseProfileCreateInput!) {
         createTrusteePurchaseProfile(input: $input) {
          ...TrusteePurchaseProfileFormFragment
         }
       }

       ${TRUSTEE_PURCHASE_PROFILE_FORM_FRAGMENT}
     `,
      variables: {
        input: trusteePurchaseProfileInput,
      },
    })
    .then(res => {
      if (res.body.errors && res.body.errors[0]) {
        throw res.body.errors[0]
      }
      return res.body.data.createTrusteePurchaseProfile
    })
}

export const updateTrusteePurchaseProfile = formData => {
  const { trusteePurchaseProfileInput } = formatFormdata(formData)

  return fetch
    .forAuctionGraph({
      query: `
       mutation ${embeddableOperation(
         'toolkitAdc_updateTrusteePurchaseProfile'
       )}($input: TrusteePurchaseProfileUpdateInput!) {
         updateTrusteePurchaseProfile(input: $input) {
          ...TrusteePurchaseProfileFormFragment
         }
       }

       ${TRUSTEE_PURCHASE_PROFILE_FORM_FRAGMENT}
     `,
      variables: {
        input: trusteePurchaseProfileInput,
      },
    })
    .then(res => {
      if (res.body.errors && res.body.errors[0]) {
        throw res.body.errors[0]
      }
      return res.body.data.updateTrusteePurchaseProfile
    })
}
